import api, { BodyParams } from "api";
import { useMutation } from "react-query";
import { Country } from "utils/market";

type BaseVars = BodyParams<"POST /invitations/therapist">;

export type Vars = BaseVars & {
  phone_number?: string;
  phone_country_code?: string;
  roles?: string[];
  therapist_type?: string;
  health_care_organization_id?: number;
  health_care_organization_name?: string;
  hip_treatment_enrollment_enabled?: boolean;
  knee_treatment_enrollment_enabled?: boolean;
  back_treatment_enrollment_enabled?: boolean;
  hand_treatment_enrollment_enabled?: boolean;
  shoulder_treatment_enrollment_enabled?: boolean;
  neck_treatment_enrollment_enabled?: boolean;
  foot_treatment_enrollment_enabled?: boolean;
  elbow_treatment_enrollment_enabled?: boolean;
  lower_leg_treatment_enrollment_enabled?: boolean;
  wrist_treatment_enrollment_enabled?: boolean;
  fall_prevention_treatment_enrollment_enabled?: boolean;
  osteoporosis_treatment_enrollment_enabled?: boolean;
};

const useInviteTherapist = () =>
  useMutation(({ country = Country.US, health_care_organization_name: _hcoName, ...rest }: Vars) =>
    api.call("/invitations/therapist", {
      method: "POST",
      data: { country, ...rest },
    })
  );

export default useInviteTherapist;
